import * as React from 'react';
import * as RX from 'reactxp';

import { colors } from '../../../utils/styles';

// tslint:disable:max-line-length
class Check extends React.Component<{style?: {[key: string]: any}, active?: boolean }> {

  constructor(props) {
    super(props);
  }

  public render() {
    const { active, style } = this.props;

    return (
      <svg height={35} width={35} viewBox='0 0 1280.000000 1280.000000' style={{...style}}>
        <g transform='translate(0.000000,1280.000000) scale(0.100000,-0.100000)'
          fill='#000000' stroke='none'>
        <path fill={style && style.color ? style.color : active ? colors.red : colors.primary} d='M9245 9030 c-408 -185 -542 -255 -790 -413 -1198 -765 -2484 -2167
-3551 -3872 -66 -104 -155 -252 -199 -327 -44 -75 -82 -137 -85 -138 -3 0 -32
60 -65 133 -225 506 -485 909 -708 1099 -175 148 -328 207 -509 194 -92 -6
-473 -91 -598 -132 -154 -52 -354 -165 -545 -309 -144 -108 -165 -129 -165
-160 0 -33 33 -65 68 -65 44 0 168 -38 235 -72 104 -52 178 -107 272 -203 285
-290 572 -862 1021 -2037 161 -421 238 -657 279 -854 3 -12 99 -105 217 -210
259 -231 275 -244 303 -244 15 0 56 35 126 106 161 165 351 337 622 562 l247
207 31 95 c517 1565 1480 3305 2600 4700 309 385 523 622 871 965 318 315 562
526 851 738 53 39 77 64 77 78 0 26 -117 308 -137 332 -9 9 -23 17 -32 17 -9
-1 -205 -86 -436 -190z'/></g>
      </svg>
    );
  }
}

export default Check;



// WEBPACK FOOTER //
// ./src/modules/svgs/check/index.web.tsx